<app-modal [show]="show" (onHide)="close()" [title]="translationManager.getTranslation('Листа запослених из свих компанија')">
  <div class="app-modal-content" style="width: 1000px !important;">
    <div class="app-table-panel" #table app-table>
      <div class="app-table-used-filters">
        <div class="app-table-used-filters-title">
          <span>{{ translationManager.getTranslation('Искоришћени филтери') }}</span>
        </div>
        <div class="app-table-used-filter-items" search-tags>
          <div class="app-table-used-filter-items-no-content" search-tag-no-content>
            <span>{{ translationManager.getTranslation('Без искоришћених филтера') }}</span>
          </div>
          <div class="app-table-used-filter-item" style="display: none" search-tag-prototype>
            <span><i search-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                search-tag-prototype-value></i></span>
            <a href="javascript:;" [title]="translationManager.getTranslation('Обрисати филтер')"
              search-tag-prototype-close>
              <i class="fas fa-times"></i>
            </a>
          </div>
          <div class="app-table-used-filter-item app-table-used-filter-item-order" style="display: none"
            order-tag-prototype>
            <span><i order-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                order-tag-prototype-value></i></span>
            <a href="javascript:;" [title]="translationManager.getTranslation('Обрисати филтер')"
              order-tag-prototype-close>
              <i class="fas fa-times"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="app-table-filter-panel" filter>
        <div class="app-table-filter-icon">
          <a href="javascript:;" [title]="translationManager.getTranslation('Филтрирај ентитете')" filter-open>
            <i class="fas fa-filter"></i>
          </a>
        </div>
        <div class="app-table-filter">
          <div class="app-table-filter-search">
            <div class="app-table-filter-title">
              <span>{{ translationManager.getTranslation('Филтери') }}</span>
              <a href="javascript:;" [title]="translationManager.getTranslation('Затвори филтер')" filter-close>
                <i class="fas fa-times"></i>
              </a>
            </div>
            <div class="page-part">
              <div class="alert alert-info">
                <span><i
                    class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Доступни филтери за процес филтрирања података') }}</span>
              </div>
            </div>
            <div class="page-part">


              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('Име и презиме') }}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="UserFullName"
                    [search-title-new]="translationManager.getTranslation('Име и презиме')" search-action="contains">
                </div>
              </div>

              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('ЕРПИД') }}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="UserErpId"
                    [search-title-new]="translationManager.getTranslation('ЕРПИД')"
                    search-action="contains">
                </div>
              </div>

              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('Компанија') }}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="Company"
                    [search-title-new]="translationManager.getTranslation('Компанија')"
                    search-action="contains">
                </div>
              </div>

              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('Организациона јединица') }}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="OrganizationalUnit"
                    [search-title-new]="translationManager.getTranslation('Организациона јединица')"
                    search-action="contains">
                </div>
              </div>
            </div>
            <div class="app-form-element-buttons">
              <button class="btn btn-success" do-search><i
                  class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Филтрирај') }}</button>
              <button class="btn btn-danger" reset-search><i
                  class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Поништи') }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="app-table" style="height: 400px !important; min-height: 0;">
        <table class="table table-striped text-dark-m1"
          style="display: flex; flex-flow: column; height: 100%; width: 100%;">
          <thead style="flex: 0 0 auto; display: table; table-layout: fixed; width: 100%;">
            <tr class="bgc-primary-tp2 text-white">
              <th style="width: 50px; "></th>

            <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по имену запосленог')" order
                    order-entity="UserFullName">
                    {{ translationManager.getTranslation('Име и презиме') }}
                </a>
            </th>
            <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по ЕРПИД-у запосленог')" order
                    order-entity="UserErpId">
                    {{ translationManager.getTranslation('ЕРПИД') }}
                </a>
            </th>
            <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по компанији запосленог')" order
                    order-entity="Company">
                    {{ translationManager.getTranslation('Компанија') }}
                </a>
            </th>
            <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по организационој јединици запосленог')" order
                    order-entity="OrganizationalUnit">
                    {{ translationManager.getTranslation('Организациона јединица') }}
                </a>
            </th>
            </tr>
          </thead>
          <tbody style="flex: 1 1 auto; display: block; overflow-y: scroll;">
            <tr *ngFor="let item of items" style="display: table; table-layout: fixed;width: 100%;">
              <td style="width: 50px;"><input type="checkbox" name="group1"
                  (click)="selectActiveEmployee(item.id, $event)"
                  [checked]="item.id === selectedId"></td>
                  <td>{{item.userFullName}}</td>
                  <td>{{item.userErpId}}</td>
                  <td>{{item.company}}</td>
                  <td>{{item.organizationalUnit}}</td>
            </tr>
          </tbody>
        </table>
        <div class="no-content" *ngIf="!items || items.length == 0">
          <span>{{ translationManager.getTranslation('Без података') }}</span>
        </div>
      </div>
      <div class="app-table-pagination">
        <div>
          <div pagination>
            <span>{{ translationManager.getTranslation('Страна') }}</span>
            <select pagination-pages>
              <option>1</option>
            </select>
            <span> {{ translationManager.getTranslation('од') }}</span>
            <span pagination-pages-count>-</span>
            <span class="app-table-pagination-arrows">
              <a href="javascript:;" [title]="translationManager.getTranslation('Иди на почетак')"
                pagination-first-page>
                <i class="fas fa-angle-double-left"></i>
              </a>
              <a href="javascript:;" [title]="translationManager.getTranslation('Претходна')" pagination-previous-page>
                <i class="fas fa-angle-left"></i>
              </a>
            </span>
            <span class="app-table-pagination-arrows">
              <a href="javascript:;" [title]="translationManager.getTranslation('Следећа')" pagination-next-page>
                <i class="fas fa-angle-right"></i>
              </a>
              <a href="javascript:;" [title]="translationManager.getTranslation('Иди на крај')" pagination-last-page>
                <i class="fas fa-angle-double-right"></i>
              </a>
            </span>
            <span>{{ translationManager.getTranslation('Број редова за приказ') }}</span>
            <select pagination-sizes>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
        <div class="app-table-pagination-sizes">
          <div>
            <span>{{ translationManager.getTranslation('Укупан број слогова') }}</span>
            <span pagination-total-count>-</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="submit()"><i
        class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Сачувај') }}</button>
    <button (click)="close()" class="btn btn-warning"><i
        class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Одустани') }}</button>
  </div>
</app-modal>
